import Lottie from 'lottie-react';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import animation from './SubscriptionFoodLoader.json';
import styles from './Loading.module.scss';

const LoadingSpoon = () => (
  <Lottie
    animationData={animation}
    loop
    autoplay
    className={styles.loading_spoon}
  />
);

export default LoadingSpoon;
